"use client";
import React from "react";
import CartSidePanel from "@/templates/common/CartSidePanel";
import {
  useEffect,
  useState,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import { SlidePanel } from "@dxp-feed/ui/SlidePanel";
import { Text } from "@dxp-feed/ui/Text";
import Loader from "@/components/Loader";
import { Toast } from "@dxp-feed/ui";

export default function UserPoints({ isDesktop }: { isDesktop?: boolean }) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
  };
  const [isOpen, setIsOpen] = useState(false);

  const openDialog = () => {
    setIsOpen(true);
  };
  const closeDialog = () => setIsOpen(false);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      togglePanel(); // Toggle the panel when Enter or Space is pressed
    }
  };
  const { isLoading } = useAppSelector((state) => state.gigyaslice);
  // const managementListData: any = useAppSelector(
  //   (state) => state?.manageListSlice
  // );
  // console.log("managementListData", managementListData);

  // const favouriteList: any = useAppSelector(
  //   (state) => state?.favouriteProductSlice
  // );
  // console.log("favouriteList", favouriteList);

  const [totalCount, setTotalCount] = useState<number>(0);
  const [showOffer, setShowOffers] = useState(true);
  const countHandler = (newCount: number | ((newCount: number) => number)) => {
    setTotalCount(newCount || 0);
  };

 
  const { offersToBeAdded } = useAppSelector(
    (state) => state.favoirateOffersSlice
  );
  // useEffect(() => {
  //   // if (
  //   //   managementListData?.itemsList?.length == 0 ||
  //   //   (managementListData?.itemsList?.length == 1 &&
  //   //     favouriteList?.listName == "Favourites")
  //   // ) {
  //   //   setShowOffers(false);
  //   // } else {
  //   //   setShowOffers(true);
  //   // }
  // }, [managementListData, offersToBeAdded]);
  useEffect(() => {
    if (isPanelOpen) {
      document.body.classList.add("noScroll");
    } else {
      document.body.classList.remove("noScroll");
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("noScroll");
    };
  }, [isPanelOpen]);

  //close manage list toggle if guide is activated
  useEffect(() => {
    const handler = () => {
      setIsPanelOpen(false);
    };
    window.addEventListener("guide-activated", handler);
    return () => window.removeEventListener("guide-activated", handler);
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isOpen) {
      timer = setTimeout(() => {
        setIsOpen(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <>
      <Box
        as="div"
        className="user-account-invoice flex-col md:flex-row md:flex items-center pt-[4px] pr-2"
        id={isDesktop ? `manage_list_desktop` : "manage_list_mobile"}
      >
        <Text as="span" className="user-invoice-icon relative inline-block">
          <Text
            as="span"
            tabIndex={0}
            onClick={togglePanel}
            onKeyDown={handleKeyDown}
            className="icon-list max-w-full w-auto mobScene text-brandWhite lg:text-brandBlack text-[24px] ml-[6px] cursor-pointer"
          ></Text>
          <Text
            as="span"
            className={`${totalCount > 99 ? "text-xs h-[22px] w-[33px] top-[-4px] right-[-20px]" : "text-[11px] lgs:text-sm h-[22px] w-[22px] lgs:h-[24px] lgs:w-[24px] -top-[2px] lg:top-[-4px] -right-[9px] lg:right-[-10px]"} invoice-items-count inline-flex items-center justify-center absolute text-brandBlack  border-[2px] border-brandSecondary  lg:border-brandWhite  font-bold leading-normal text-center  bg-primary400 opacity-1 rounded-full pt-[1px] pointer-events-none`}
          >
            {!isLoading && showOffer
              ? totalCount > 99
                ? "99+"
                : totalCount
              : 0}
          </Text>
        </Text>
        {isOpen && (
          <Toast
            message={
              <Box
                as="div"
                className="flex flex-col md:justify-between md:flex-row items-start p-0 gap-[10px]"
              >
                <Text
                  as="p"
                  className="text-body text-brandBlack !font-light pb-[0px]"
                >
                  <Text as="span" className="!font-normal">
                    Your offer was successfully removed from your Shopping List.
                  </Text>
                </Text>
              </Box>
            }
            onClose={() => {}}
            position="top"
            autoCloseDuration={3000}
            closeButton={
              <span
                onClick={closeDialog}
                className={`icon-close text-brandBlack font-bold ml-3 cursor-pointer`}
              />
            }
            className={`max-w-[90%] md:max-w-[575px] w-[100%] outline-none bg-primary100 top-[150px] z-[9999999999]`}
          />
        )}
      </Box>
      <SlidePanel
        side="right"
        isOpen={isPanelOpen}
        className="w-full md:w-[512px] z-[999999]"
        overlayClass="bg-overlay"
        onClose={togglePanel}
      >
        <Box as="div" className="relative h-full">
          <Box
            as="div"
            className="absolute top-0 left-0 right-0 bg-brandWhite z-[2] h-[77px]"
          >
            <Box
              as="div"
              className="flex items-center justify-between p-6 border-b-1	border-b border-grey350 h-[77px]"
            >
              <Box as="div">
                <Box
                  as="div"
                  className="text-base text-brandBlack capitalize font-bold"
                >
                  Your Shopping List
                </Box>
              </Box>
              <Button
                className="text-gray-500 font-bold text-lg"
                onClick={togglePanel}
                aria-label="Close modal"
                variant="icon"
                size="none"
              >
                <Text
                  as="span"
                  className="icon-close text-grey950 text-[14px]"
                ></Text>
              </Button>
            </Box>
          </Box>
          <CartSidePanel
            setIsPanelOpen={setIsPanelOpen}
            productCount={totalCount}
            countHandler={countHandler}
            sidePanelOpen={isPanelOpen}
            showOffers={showOffer}
            openDialog={openDialog}
          />
        </Box>
      </SlidePanel>
    </>
  );
}